"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DirectionCommand = void 0;
const ScrollDirection_1 = require("../../common/ScrollDirection");
const Command_1 = require("../Command");
const CommandType_1 = require("../lib/CommandType");
/**
 * Scrolling direction for the notes following this command. Can be placed in
 * the middle of a measure.
 *
 * **Example:**
 *
 * ```
 * #DIRECTION 2
 * ```
 */
class DirectionCommand extends Command_1.Command {
    constructor(direction) {
        super(CommandType_1.CommandType.Direction);
        this.direction = direction;
    }
    static parse(args, strict) {
        if (args.length === 0) {
            return undefined;
        }
        const direction = ScrollDirection_1.ScrollDirection.fromRaw(args[0], strict);
        if (!direction) {
            return undefined;
        }
        return new DirectionCommand(direction);
    }
    toString() {
        return `${super.toString()} ${this.direction}`;
    }
}
exports.DirectionCommand = DirectionCommand;
